
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/wetter",
      function () {
        return require("private-next-pages/[region]/[resort]/wetter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/wetter"])
      });
    }
  